// extracted by mini-css-extract-plugin
export default {"form":"styles_form__dbFqc","container":"styles_container__NG4uQ","input":"styles_input__uyKnh","image":"styles_image__hE44p","headerContainer":"styles_headerContainer__hI5Y2"};